export const isIesWhite = () => {
  // 是否视频 9:16白名单
  const { ies_white } = window.WHITE_LIST_OBJECT || {};
  return !!ies_white;
};

//  tt ies语言白名值, 全部开放的话就挪到inventory-type.js对应的配置选项。
export const whiteLanguages = {
  JP: 'ja',
  TW: 'zh-Hant',
  IN: 'en',
  US: 'en',
  KR: 'ko',
  TH: 'th',
  MY: 'ms',
  ID: 'id',
  VN: 'vi',
  GB: 'en',
  DE: 'de',
  FR: 'fr',
  IT: 'it',
  ES: 'es',
  TR: 'tr',
  SA: 'ar',
  RU: 'ru',
  AE: 'ar',
  EG: 'ar',
};

// https://wiki.bytedance.net/pages/viewpage.action?pageId=323716087
// white_value 白名单常量值
export const whiteValue = {
  // ies mt 白名单
  mt: 1,
  // ocpm
  ocpm: 2,
  // 开发pixel链接
  pixel: 3,
  // i18n新平台
  i18n_upgrade: 4,
  // ies jp 开放tw地区和语言白名单,已全量
  mt_jp: 5,
  // ies tw 开放tw地区和语言白名单，已全量
  mt_tw: 6,
  // 代理商币种合同白名单
  currency_white: 7,
  // dmp 白名单
  dmp: 8,
  // 印度tt白名单，已全量
  mt_in: 9,
  // 美国tt白名单
  mt_us: 10,
  // nr 台湾白名单
  nr_tw: 11,
  mt_kr: 12,
  mt_th: 13,
  mt_my: 14,
  mt_id: 15,
  mt_vn: 16,
  mt_uk: 17,
  mt_de: 18,
  mt_fr: 19,
  mt_it: 20,
  mt_es: 21,
  mt_tr: 22,
  mt_sa: 23,
  mt_ru: 24,
  // 新增22个竞价国家定向
  mt_brazil: 72,
  mt_mexico: 73,
  mt_ukraine: 74, // 乌克兰
  mt_belarus: 75,
  mt_hungary: 76,
  mt_czech: 77,
  mt_romania: 78,
  mt_kuwait: 79,
  mt_qatar: 80,
  mt_oman: 81,
  mt_bahrain: 82,
  mt_newZealand: 83,
  mt_phli: 84,
  mt_sweden: 85,
  mt_netherlands: 86,
  mt_norway: 87,
  mt_finland: 88,
  mt_denmark: 89,
  mt_switzerland: 90,
  mt_belgium: 91,
  mt_austria: 92,
  mt_ireland: 93,

  // nr韩国白名单
  bv_kr: 25,
  mt_ae: 26, // 阿联酋
  mt_eg: 27, // 埃及
  bv_in: 28, // 印尼
  bb_in: 29, // babe 印尼
  tt_ad_network: 30, // 穿山甲placemnet 自动、手动都披露rit
  dynamic_creative: 31, // 程序化创意
  vigo: 32, // vigo placemnet 自动、手动模式都披露rit
  tt_ad_network_auto_disable: 33, // 不出网盟rit自动，只显示手动
  tt_ad_network_select_disable: 34, // 不出网盟rit手动，只显示自动
  helo: 35, // helo placemnet 自动、手动模式都披露rit
  smart_bid_strategy: 36, // maxcv bid 后面会下掉
  max_conversion_no_bid: 56,
  deeplink: 37,
  defferedDeeplink: 71, // defferedDeeplink的白名单
  reach: 38, // 品牌reach白名单
  videoView: 39, // 品牌videoView白名单
  brand_safety: 40, // brand_safety
  mt_au: 42, // TikTok 澳大利亚
  mt_ca: 43, // TikTok 澳大利亚
  mt_hk: 44, // TikTok 香港
  playable: 46, // 试玩广告
  deep_goal: 47, // 深度转化白名单
  split_test: 50, // split_test白名单
  deep_convertion: 51, // 深度转化数据披露白名单
  mt_il: 52, // TikTok 以色列
  mt_pl: 53, // TikTok 波兰
  pangle_image: 54, // pangle图片版位
  // pangle_kr: 55, // pangle 韩国
  // pangle_tailand: 64, // pangle 泰国
  // pangle_taiwan: 65, // pangle 台湾
  behavior_target: 57, // 行为定向
  bulkDownload: 58, // 批量一期下载
  bulkUpload: 59, // 批量二期上传
  moat_tagless: 60, // moat tagless 白名单
  track_DV: 458, // dv白名单
  track_view_IAS: 473, // viewability IAS 白名单
  nativeBrandAdWhite: 61, // tiktok达人视频拉取
  postPay: 63, // 自助后付款白名单
  appRetarget: 69, // App retargeting
  split_test_creative: 68, // split test创意层级
  creativeCopy: 70, // 支持创意复制
  traffic_sink: 97, // traffic 下沉结构,
  conversion_sink: 99, // conversion 下沉结构,
  reach_sink: 100, // reach 下沉结构
  videoview_sink: 101, // video view 下沉结构
  dpa_sink: 102, // Dpa下沉
  pangle_mideast: 103, // 国际化网盟-中东地区定向
  pangle_southeast_asia: 104, // 国际化网盟-东南亚地区定向
  pangle_sa: 103,
  pangle_ae: 103,
  pangle_eg: 103,
  pangle_tr: 103,
  pangle_vn: 104,
  pangle_my: 104,
  pangle_th: 104,
  bid_ocpm: 120, // oCPM 二期
  dpa_app_retargeting: 111, // DPA支持app重定向
  dpa_app_install: 112, // DPA支持app安装
  dpa_website_retargeting: 113, // DPA支持website重定向
  dpa_website_prospecting: 114, // DPA支持website非重定向
  native_ad_traffic: 134,
  native_ad_appinstall: 135,
  native_ad_conversion: 136,
  rf: 151, // rf广告白名单
  hide_suggestion_list: 475, // 屏蔽adgroup诊断列白名单
  campaign_planer: 329, // 效率工具 campaign planer
  campaign_budget_optimization: 117, // CBO Campaign层级预算择优分配
  campaign_budget_optimiza_lifetime: 487, // CBO budget是否展示lifetime
  campaign_budget_optimize_vo_normal_highest_value: 518, // CBO VO highest value
  campaign_budget_optimize_vo_min_roas: 519, // CBO VO min roas
  isNewStructure: 98,
  videoTrackLink: 152, // 视频播放三方链接白名单
  isLeadAds: 154,
  auction_collection_ads: 243, // Collection Ads 创意
  brand_auction_collection_ads: 308, // Reach & VV 支持 Collection Ads 创意
  collection_ads_app: 479, // App 支持 Collection Ads
  collection_ads_image_card: 279, // Collection Ads 创编中添加图片卡片
  mrc_play_count: 203, // MRC 指标 连续播放2秒次数 白名单
  modelSole: 206,
  modelSoleAmazon: 207,
  postPayCash: 204, // 预付费原生收银台白名单
  isSplitTestBidding: 205, // split test bidding白名单
  engagement: 223,
  carouselImage_v1: 209, // 多图轮播1.0
  carouselImage_v2: 242, // 多图轮播2.0
  aco_presented_video: 224, // 程序化赠送视频白名单
  aco_presented_video_preview: 283, // 赠送视频2.0用于区分高风险/低风险地区的白名单
  campaign_engagement: 223, // engagement 指标显示的白名单，位置是campaign/ad/ad group层级(包括viewData)的自定义列和reporting部分的metrics
  gross_impression: 238, // 无效流量指标白名单，控制未来竞价平台上的无效流量指标
  captureImageFromVideoTool: 239, // 视频抽帧转图片工具
  // creative_authorization: 240, // 创意素材授权 // 下线
  // creative_authorization_default_checked: 244, // 创意素材授权是否为默认勾选状态 // 下线
  native_ad_rf: 241, // RF支持原生广告
  brand_safety_flagship: 245, // 竞价三方品牌安全白名单
  brand_safety_open_slate: 546, // 竞价三方品牌安全OpenSlate白名单
  brand_safety_ias: 547, // 竞价三方品牌安全IAS白名单
  newBrandSafetyInventory: 581, // 新一方品牌安全RF
  pangle_ocpx_nobid: 254, // 直投pangle ocpm ocpc 支持 no bid
  pangle_cpc_nobid: 255, // 直投pangle cpc 支持 no bid
  inspect: 248, // 诊断白名单
  dma: 249, // 美国地域定向 DMA
  cta_auto_optimized: 247, // dynamic cta针对DPA的白名单
  creative_video_editor: 264, // 视频编辑器
  athena_intelligent_caller: 265, // 右下角雅典娜智能客服
  scheduled_budget: 267, // 定时预算
  coldBoot: 269, // 冷启动白名单
  new_creative_detail: 256, // 接口迁移，新creative/detail普通创意接口 白名单
  new_creative_procedural_detail: 257, // 接口迁移， 新creative/detail程序化创意接口 白名单
  new_creative_list: 258, // 接口迁移，新创意列表creative/list接口 白名单
  comment_manage: 266, // 统计列表评论管理入口
  ios14_drop: 270, // 只支持traffic cpc，方案三
  ios14_only_cpc: 271, // 支持ios app cpc方案2
  ios14_mvp: 272, // 支持ios app cpc ocpc方案三
  ios14_dialog: 273, // 控制iOS14弹窗展示
  refactor_creation: 281, // 跳转到重构后的创编流程
  vo_dpa: 284,
  targeting_recommendation: 275, // 定向推荐
  targeting_recommendation_newui: 484, // 定向推荐新UI
  reporting_v5: 231, // 数据中台5期(Reporting)
  targeting_expansion: 276, // 定向扩量
  catalog_asset: 277, // 商品库
  s4smb_custom_mode: 288, // 默认禁止导入pclite白名单
  additional_customized_image_card: 285, // 附加创意自定义图片卡
  additional_customized_game_gift_card: 286, // 附加创意游戏礼包卡
  additional_customized_instant_page: 287, // 附加创意轻自定义落地页
  additional_rf_customized_instant_page: 414, // RF 附加创意轻自定义落地页
  native_music_promote: 290, // 原生视频推广音乐
  ios14_multiple: 307,
  account_and_asset_linking: 282, // 创意使用 Identity 新结构
  upgraded_viewdata: 305, // 受众分析升级
  interest_keywords: 310, // 兴趣关键词定向
  dpa_inventory_flow_pangle_app: 314, // DPA x Pangle x APP
  dpa_inventory_flow_pangle_msite: 486, // DPA x Pangle x msite
  smb_diagnose: 311, // smb诊断白名单
  audit_reject_appeal: 316, // 创意创建预览使用二维码预览
  creative_preview_with_qrcode: 317, // 创意创建预览使用二维码预览
  diagnosis_suggestion_v2: 319, // 诊断建议2.0白名单
  reporting_ttads: 232, // ad.site.statistics_i18n 报告接口迁移tt_ads
  rf_appinstall: 332, // rf appinstall白名单
  contact_service: 326, // 拒审建议界面雅典娜工单入口白名单
  brandSafetyInventory: 327, // 一方品牌安全
  rf_engagement: 360, // rf eo白名单
  app_profile_instant_page: 320, // app profile instant page 白名单
  capitalization: 318, // 商品库资产化白名单
  need_capitalized: 579, // 商品库需要资产化白名单，否则广告会下线
  aco_max_upload: 324, // aco最大上传视频数量封印，如果有白名单，可以上传30个，如果没有白名单只能上传10个
  split_test_support_ios_14: 325, // split test 白名单
  bulk_edit: 330,
  automated_rules: 331, // 自动规则
  rf_support_wip: 335, // RF站内导流跳转
  rf_only_support_wip: 481, // RF仅支持站内导流跳转
  traffic_cbo: 339,
  vv_cbo: 340,
  reach_cbo: 341,
  engagement_cbo: 342,
  dpa_cbo: 419,
  aeo_cbo: 476,
  lead_ads_cbo: 418,
  rf_statistics_upgrade: 338, // RF 统计接口迁移
  pcm_phase1: 358,
  pcm_phase2: 359,
  search_ads: 545, // searchAds白名单，只有在开白的情况下TT版位才才能出现开关
  search_ads_preview: 396, // 控制searchAds中披露给广告主的样式
  ttba_push_native_video: 346,
  tiktok_duet_stitch_auth: 391, // 原生帖子双授权
  zefrWhite: 337,
  pixel_standard: 395,
  shop: 336, // objective shop monetization
  AUTOMATED_TARGETING: 343, // pc lite 自动定向白名单
  BUDGET_LIMIT_REDUCTION: 344, // pc lite 预算限制下调，命中白名单的用户可以创建预算更低的广告
  vo_appinstall_standard: 280, // VO在 AppInstalls 下 CostCap 方式的白名单
  vo_appinstall_roas: 374, // VO在 AppInstalls 下 ROAS 方式的白名单
  vo_conversions_app_standard: 375, // VO在 Conversions-App 下 CostCap 方式的白名单
  vo_conversions_app_roas: 376, // VO在 Conversions-App 下 ROAS 方式的白名单
  vo_conversions_web_standard: 377, // VO在 Conversions-WEB 下 CostCap 方式的白名单
  vo_conversions_web_roas: 378, // VO在 Conversions-WEB 下 ROAS 方式的白名单
  vo_dpa_app_standard: 284, // VO在 DPA 下 CostCap 方式的白名单
  vo_dpa_app_roas: 379, // VO在 DPA-App 下 ROAS 方式的白名单
  vo_dpa_web_standard: 380, // VO在 DPA-WEB 下 CostCap 方式的白名单
  vo_dpa_web_roas: 381, // VO在 DPA-WEB 下 ROAS 方式的白名单
  vo_pangle_appinstall_standard: 452, // vo pangle appinstall costcap白名单
  vo_pangle_appinstall_roas: 453, // vo pangle appinstall roas白名单
  aco_support_cta_optimized: 399, // ACO 支持CTA优选
  tiktok_playable_ads: 373,
  lead_ads_crm: 397, // Lead ads 集成 CRM
  rf_gesture: 362, // rf 附加创意手势
  rf_painted_egg: 363, // rf 附加创意彩蛋
  disclaimer: 382,
  rfDisclaimer: 544,
  SHOP_LIVE: 405,
  smb_suggestion_v2: 392, // SMB诊断2.0
  new_identity: 445, // 新identity
  ttp_support: 411, // TTP 白名单
  ttp_statistics_api: 421, // ttp 受众分析接口白名单，接口放量与业务 GTM 节奏不同，用两个枚举值
  ttp_viewdata_reporting: 516, // ttp 受众分析 使用 516，与其它业务方区分
  diagnosis_two_point_one: 417, // suggestion2.1
  aco_reporting_upgrade: 415, // ACO报表升级白名单
  automated_rules_today_conversion: 448,
  rf_dmp: 398, // rf支持dmp
  hashtag: 446, // 行为 hashtag 定向白名单
  videoUploadfrontPrecheck: 459,
  ttp_banner: 460, // 内部用户 ttp banner 披露白名单
  attachement_creative_refact: 420, // Instant Experience 创意流程重构
  bulletboard: 464, // 首页宣传栏
  dc_multiple_five: 466,
  rf_creative_mode: 455, // rf 支持多素材播放方式
  cmo_v2: 461, // CMO 二期
  video_shopping_multi_products: 472, // video shopping多商品
  brand_track_data: 467,
  dpa_image: 469, // dpa pangle支持image
  rf_pi: 474, // premium inventory 白名单
  context_target: 571, // 展示上下文定向白名单
  context_target_premium: 572, // 展示上下文 permium topic 白名单
  cmo_name_sort: 482, // CMO 支持name列排序
  shop_multiple_attribution: 485,
  library_dashboard: 493, // 添加素材库首页
  industry_type: 495, // 广告行业类型白名单
  refactor_creation_smb: 497, // smb用户跳转重构创编
  bsIasWhite: 503, // brand safety ias产品
  bsDvWhite: 624, // brand safety ias产品
  shop_live_optimize_goal_product_click: 507, // shop live ads优化目标支持product click
  shop_live_optimize_goal_initate_checkout: 508, // shop live ads优化目标支持initate
  shop_live_optimize_goal_complete_payment: 589, // shop live ads优化目标支持complete payment
  rf_90_days__delivery: 509, // 预定活动开放90天
  rf_adgroup_copy: 539, // rf复制广告组
  perf_total_async: 510, // Campaign List 汇总行拆分请求
  ttp_2fa: 517, // 2fa 白名单
  comment_new: 514, // 新版评论管理
  budget_recommend: 515, // 预算推荐白名单
  pharmacy_qualification: 526, // 医药资质白名单
  music_qualification_simplified_submission: 527, // 音乐资质简洁流程
  perf_table_optimize: 528, // 表格优化改造 白名单
  perf_list_cache: 529, // 短时切换 tab 使用缓存
  in_market_target: 531, // in-market 定向白名单
  app_profile_page_support_cost_cap: 532, // app profile page 支持 cost cap
  required_creative: 533, // Campaign List 按需请求投前指标白名单 533
  ttp_uv: 541, // ttp reporting uv 白名单
  URL_SUPPORT_EDIT: 537, // url是否支持编辑
  hide_pixel_event: 538, // 隐藏优化事件白名单
  rf_fe_refactor: 560, // RF 前端重构白名单
  Newcomment: 568, // 评论管理白名单
  search_ads_mt: 545, // 搜索广告明投白名单 545
  split_test_entry: 552, // Split Test 投中入口
  htc: 480, // HTC 计费回显
  dashboard_api_optimize: 587, // Dashboard 接口优化
  dsa_with_collection_ad: 590, // dsa*ca白名单
  high_household_income: 595, // hhi白名单
  shop_ads_product_anchor: 607, // shop prodcut anchor白名单
  aeo_dc_cost_cap: 573, // dc aeo支持cost cap白名单
  refactor_creation_create_campaign: 663, // panda强制跳转到creation campaign兜底白名单
  migration_dsa_ca_phase_two: 725,
  migration_dsa_ca_phase_three: 726,
  migration_dsa_ca_phase_four: 727,
  migration_dsa_ca_no_migrate: 728,
  migration_dsa_ca: 729,
  ads_manager_clover: 744, // Clover 白名单

  migrate_shop_purchase_exclude: 783, // 豁免 SHOP PURCHASE 新增
  migrate_shop_purchase: 784, // 禁用 SHOP PURCHASE 新增

  migrate_shop_purchase_edit_copy_exclude: 802, // 豁免 SHOP PURCHASE 编辑、复制
  migrate_shop_purchase_phase2: 801, // 禁用 SHOP PURCHASE 编辑、复制

  // 自动规则
  automatic_rule_support_new_schedule: 830, // 自动规则 新版本run schedule + 仅运行一次白名单
};

const whiteHelper = value => () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(value) >= 0;
};
export const isBrandTrackDataWhite = whiteHelper(whiteValue.brand_track_data);

export const isNewCommentWhite = whiteHelper(whiteValue.Newcomment);

export const isRefactorCreationCreateCampaignWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.refactor_creation_create_campaign) >= 0;
};

export const isPixelStandardWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.pixel_standard) >= 0;
};
export const isAeoCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.aeo_cbo) >= 0;
};
export const isTrafficCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.traffic_cbo) >= 0;
};
export const isVVCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.vv_cbo) >= 0;
};
export const isReachCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.reach_cbo) >= 0;
};
export const isEngagementCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.engagement_cbo) >= 0;
};
export const isDpaCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.dpa_cbo) >= 0;
};
export const isLeadAdsCboWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.lead_ads_cbo) >= 0;
};
export const isPcmPhase1White = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.pcm_phase1) >= 0;
};
export const isPcmPhase2White = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.pcm_phase2) >= 0;
};

export const isBudgetRecommendWhite = whiteHelper(whiteValue.budget_recommend);

export const isInMarketTargetWhite = whiteHelper(whiteValue.in_market_target);
export const isAutoTargetingEnabled = whiteHelper(whiteValue.AUTOMATED_TARGETING);
export const isBudgetReductionEnabled = whiteHelper(whiteValue.BUDGET_LIMIT_REDUCTION);
export const isDiagnosis2Point1 = whiteHelper(whiteValue.diagnosis_two_point_one);

export const isBulkEditWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.bulk_edit) >= 0;
};
export const isAcoReportingUpgradeWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.aco_reporting_upgrade) >= 0;
};

export const isIOS14MultipleTwoWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.ios14_multiple) >= 0;
};
export const isIOS14MultipleFiveWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.dc_multiple_five) >= 0;
};

// 一对多的白名单，，分两种一种是1对2，一种是一对5
export const isIOS14MultipleWhite = () => isIOS14MultipleTwoWhite() || isIOS14MultipleFiveWhite();
export const isDiagnosisV2White = whiteHelper(whiteValue.diagnosis_suggestion_v2);
export const isSmbDiagnoseWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.smb_diagnose) >= 0
    || white_value.indexOf(whiteValue.smb_suggestion_v2) >= 0;
};
export const isIOS14StatisticWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.ios14_only_cpc) >= 0
    || white_value.indexOf(whiteValue.ios14_mvp) >= 0;
};
export const isIOSDialog = whiteHelper(whiteValue.ios14_dialog);
// 命中ios14任意一种方案
export const hitIOSAnyOne = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.ios14_drop) >= 0
    || white_value.indexOf(whiteValue.ios14_only_cpc) >= 0
    || white_value.indexOf(whiteValue.ios14_mvp) >= 0;
};
export const isModelSoleWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.modelSole) >= 0 && white_value.indexOf(whiteValue.modelSoleAmazon) >= 0;
};

export const isLeadAdsWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.isLeadAds) >= 0;
};
export const isVideoTrackLinkWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.videoTrackLink) >= 0;
};
export const isStoreFrontsPlpWhite = whiteHelper(whiteValue.auction_collection_ads);

export const isBrandAuctionCAWhite = whiteHelper(whiteValue.brand_auction_collection_ads);

export const isCollectionAdsImageCardWhite = whiteHelper(whiteValue.collection_ads_image_card);

export const isCollectionAdsAppWhite = whiteHelper(whiteValue.collection_ads_app);

export default whiteValue;
export const isAgentCurrencyWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.currency_white) >= 0;
};

// 美国tt白名单
export const isMtUSWhite = whiteHelper(whiteValue.mt_us);

// 多币种合同白名单
export const isBulkDownloadWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.bulkDownload) >= 0;
};
export const isBulkUploadWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.bulkUpload) >= 0;
};
// app retarget白名单
export const isAppRetargetWhite = function () {
  const { white_value = [] } = window && window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.appRetarget) >= 0;
};
export const isDeeplinkWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.deeplink) >= 0;
};
export const isNewStructureWhite = function () { // 是url下沉后的app新结构的白名单
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.isNewStructure) >= 0;
};
export const isDefferedDeeplinkWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.defferedDeeplink) >= 0;
};
export const isRFWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.rf) >= 0;
};

export const isRFRefactorWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.rf_fe_refactor) >= 0 && isRFWhite(); // 需要同时满足 rf 白名单和前端重构白名单
};

export const isHideSuggestionListWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.hide_suggestion_list) >= 0;
};
export const isCommentNewWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.comment_new) >= 0;
};

export const isAppProfilePageSupportCostCap = whiteHelper(whiteValue.app_profile_page_support_cost_cap);

// VO出价白名单
export const isVoAppInstallStandardWhite = whiteHelper(whiteValue.vo_appinstall_standard);
export const isVoAppInstallRoasWhite = whiteHelper(whiteValue.vo_appinstall_roas);
export const isVoConversionsAppStandardWhite = whiteHelper(whiteValue.vo_conversions_app_standard);
export const isVoConversionsAppRoasWhite = whiteHelper(whiteValue.vo_conversions_app_roas);
export const isVoConversionsWebStandardWhite = whiteHelper(whiteValue.vo_conversions_web_standard);
export const isVoConversionsWebRoasWhite = whiteHelper(whiteValue.vo_conversions_web_roas);
export const isVoDpaAppStandardWhite = whiteHelper(whiteValue.vo_dpa_app_standard);
export const isVoDpaAppRoasWhite = whiteHelper(whiteValue.vo_dpa_app_roas);
export const isVoDpaWebStandardWhite = whiteHelper(whiteValue.vo_dpa_web_standard);
export const isVoDpaWebRoasWhite = whiteHelper(whiteValue.vo_dpa_web_roas);
export const isVoPangleInstallRoasWhite = whiteHelper(whiteValue.vo_pangle_appinstall_roas);
export const isVoPangleInstallStandardWhite = whiteHelper(whiteValue.vo_pangle_appinstall_standard);

// DPA支持app重定向
export const isDpaAppRetargetingWhite = whiteHelper(whiteValue.dpa_app_retargeting);

// DPA支持app安装
export const isDpaAppInstallWhite = whiteHelper(whiteValue.dpa_app_install);

// DPA支持website重定向
export const isDpaWebsiteRetargetingWhite = whiteHelper(whiteValue.dpa_website_retargeting);

// DPA支持website非重定向
export const isDpaWebsiteProspectingWhite = whiteHelper(whiteValue.dpa_website_prospecting);

// 支持商品库
export const isCatalogAssetWhite = whiteHelper(whiteValue.catalog_asset);

// 历史遗留坑的处理：DPA相关的几个白名单任开一个，就认为可见DPA
// https://bytedance.feishu.cn/docs/doccnIPhuos5RIiRHIsmDjAiaYe#
export const isDpaWhite = function () {
  return (
    isDpaAppRetargetingWhite() ||
    isDpaAppInstallWhite() ||
    isDpaWebsiteRetargetingWhite() ||
    isDpaWebsiteProspectingWhite()
  );
};

// DPA X Pangle支持app
export const isDpaPangleAppWhite = whiteHelper(whiteValue.dpa_inventory_flow_pangle_app);

// DPA X Pangle支持msite
export const isDpaPangleWebsiteWhite = whiteHelper(whiteValue.dpa_inventory_flow_pangle_msite);

// DPA支持投放Pangle(APP or msite)
export const isDpaPangleWhite = () => isDpaPangleAppWhite() || isDpaPangleWebsiteWhite();

export const isSmartBidStrategyWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.smart_bid_strategy) >= 0;
};
export const isMaxConversionNoBidWhite = () => {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.max_conversion_no_bid) >= 0;
};

// vigo
export const isVigoWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.vigo) >= 0;
};

export const isBrandSafetyWhite = function () {
  // const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  // return white_value.indexOf(whiteValue.brand_safety) >= 0;
  // 此功能暂未开启，暂且关闭
  return false;
};

/** 竞价三方品牌安全 */
export const isBrandSafetyFlagShipWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.brand_safety_flagship) >= 0;
};

/** 竞价三方品牌安全OpenSlate */
export const isOpenSlateWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.brand_safety_open_slate) >= 0;
};

/** 竞价三方品牌安全IAS */
export const isIasWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.brand_safety_ias) >= 0;
};

/** 一方品牌安全 */
export const isBrandSafetyInventoryWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.brandSafetyInventory) >= 0;
};

/** 新一方品牌安全 */
export const isNewBrandSafetyInventoryWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.newBrandSafetyInventory) >= 0;
};

// playable
export const isPlayableWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.playable) >= 0;
};

// 深度转化数据披露白名单
export const isDeepConvertWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.deep_convertion) >= 0;
};

export const isSplitTestWhite = () => true;

// Pangle投放图片
export const isPangleImageWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.pangle_image) >= 0;
};

// tiktok达人视频拉取 ,reach和videoview共用一个白名单
export const isNativeBrandAdWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.nativeBrandAdWhite) >= 0;
};
export const isNativeAdTrafficWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.native_ad_traffic) >= 0;
};
export const isNativeAdAppInstallWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.native_ad_appinstall) >= 0;
};
export const isNativeAdAppConversionWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.native_ad_conversion) >= 0;
};
export const isNativeAdRFWhite = whiteHelper(whiteValue.native_ad_rf);

// split test创意层级
export const isSplitTestCreativeWhite = whiteHelper(whiteValue.split_test_creative);

// 是否多shop归因白名单
export const isShopMultipleAttr = whiteHelper(whiteValue.shop_multiple_attribution);

// https://wiki.bytedance.net/pages/viewpage.action?pageId=333075084
// 印尼语语言码in改ID
// https://wiki.bytedance.net/pages/viewpage.action?pageId=332691546
export const tbnrWhite = {
  // nr_tw: {
  //   country: ['TW'],
  //   language: ['zh-Hant'],
  //   // InventoryType value List
  // },
  // bv_kr: {
  //   country: ['KR'],
  //   language: ['ko'],
  //   rit: [11211084, 11211083, 11211009, 11211003, 11211001],
  // },
  bv_in: {
    // 印尼
    country: ['ID'],
    language: ['id'],
    rit: [11124003, 11124001],
  },
  bb_in: {
    // 印尼
    country: ['ID'],
    language: ['id'],
    rit: [11125003, 11125001],
  },
};

/**
 * 自助地域定向黑名单
 * wiki: https://bytedance.feishu.cn/docs/doccnh1AecyyO346BbT4ue5hp5e
 * 2020.3.16：再加上台湾中东等7个地区 (台湾，韩国，土耳其、沙特、阿联酋、埃及、巴西及其省份)
 * doc: https://bytedance.feishu.cn/docs/doccnDkQdw44vjg97m5MsrTNFCb
 * 2020-04-15 放开 俄罗斯、韩国、埃及
 * 2020-05-26 放开土耳其、沙特、阿联酋
 */
// export const selfBlackCountryCode = ['RU', 'TW', 'KR', 'TR', 'SA', 'AE', 'EG', 'BR'];
export const selfBlackCountryCode = ['TW'];

// 是否信用卡后付款白名单
export const isPostPayWhite = whiteHelper(whiteValue.postPay);
export const isEngagementWhite = whiteHelper(whiteValue.engagement);
// 支持创意复制
export const isInCopyCreativeWhite = whiteHelper(whiteValue.creativeCopy);

// CBOwhiteHelper
export const isCBOWhite = whiteHelper(whiteValue.campaign_budget_optimization);

// CBO lifetime是否展示
export const isCBOLifetimeWhite = whiteHelper(whiteValue.campaign_budget_optimiza_lifetime);

// CBO VO Highest Value
export const isCBOVOHighestValueWhite = whiteHelper(whiteValue.campaign_budget_optimize_vo_normal_highest_value);

// CBO VO Min Roas
export const isCBOVOMinRoasWhite = whiteHelper(whiteValue.campaign_budget_optimize_vo_min_roas);
/** 广告行业类型白名单 */
export const isIndustryTypeWhite = whiteHelper(whiteValue.industry_type);

// MRC 指标白名单
export const isMRCWhite = whiteHelper(whiteValue.mrc_play_count);

// 行为定向
export const isBehaviorWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.behavior_target) >= 0;
};

export const isSplitTestBiddingWhite = whiteHelper(whiteValue.isSplitTestBidding);

// 下沉Objetive的白名单
export const isSinkTrafficWhite = whiteHelper(whiteValue.traffic_sink);
export const isSinkConversionWhite = whiteHelper(whiteValue.conversion_sink);
export const isSinkReachWhite = whiteHelper(whiteValue.reach_sink);
export const isSinkVideoViewWhite = whiteHelper(whiteValue.videoview_sink);
export const isSinkDpaWhite = whiteHelper(whiteValue.dpa_sink);
// 多图轮播
export const isCarouselImageCreativeAllowed_v1 = whiteHelper(whiteValue.carouselImage_v1);
export const isCarouselImageCreativeAllowed_v2 = whiteHelper(whiteValue.carouselImage_v2);
export const isCarouselImageCreativeAllowed = isCarouselImageCreativeAllowed_v1 || isCarouselImageCreativeAllowed_v2;
// engagement指标的访问，六个任有其一就可以浏览
export const isEngagementMetricsWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  const {
    nativeBrandAdWhite, native_ad_traffic, native_ad_appinstall, native_ad_conversion, campaign_engagement, native_ad_rf,
  } = whiteValue;
  return [nativeBrandAdWhite, native_ad_traffic, native_ad_appinstall, native_ad_conversion, campaign_engagement, native_ad_rf]
    .some(key => white_value.includes(key));
};
// engagement指标中的 follow 白名单单独设置
export const isFollowMetricsWhite = whiteHelper(whiteValue.campaign_engagement);

// 程序化赠送视频白名单
export const isAcoPresentedVideoWhiteList = whiteHelper(whiteValue.aco_presented_video);
// 赠送视频2.0用于区分高/低风险地区白名单
export const isHightRiskAreas = whiteHelper(whiteValue.aco_presented_video_preview);

// 无效流量指标白名单，控制未来竞价平台上的无效流量指标
export const isGrossImpressionMetricsWhite = function () {
  const { white_value = [] } = window.WHITE_LIST_OBJECT || {};
  return white_value.indexOf(whiteValue.gross_impression) >= 0;
};
export const isCaptureImageFromVideoToolEnable = whiteHelper(whiteValue.captureImageFromVideoTool);
export const isPangleOcpxNobidWhite = whiteHelper(whiteValue.pangle_ocpx_nobid);
export const isPangleCPCNobidWhite = whiteHelper(whiteValue.pangle_cpc_nobid);
export const isInspectWhite = whiteHelper(whiteValue.inspect);
// CTA文案优选白名单
export const isCtaAutoOptimizedWhite = whiteHelper(whiteValue.cta_auto_optimized);

// 创意中心视频编辑器
export const isCreativeVideoEditorEnable = whiteHelper(whiteValue.creative_video_editor);
// 雅典娜智能客服
export const isAthenaIntelligentCallerWhite = whiteHelper(whiteValue.athena_intelligent_caller);

// 评论管理入口
export const isCommentManageWhite = whiteHelper(whiteValue.comment_manage);

// 新普通创意接口白名单
export const isNewCreativeDetailWhite = whiteHelper(whiteValue.new_creative_detail);
// 新程序化创意接口白名单
export const isNewCreativeProceduralDetailWhite = whiteHelper(whiteValue.new_creative_procedural_detail);
// 新创意列表接口白名单
export const isNewCreativeListWhite = whiteHelper(whiteValue.new_creative_list);
// 冷启动是否展示白名单
export const isColdBoot = whiteHelper(whiteValue.coldBoot);

export const isReportingV5White = whiteHelper(whiteValue.reporting_v5);

// 跳转到重构后的创编流程
export const isRefactorCreationWhite = whiteHelper(whiteValue.refactor_creation);
// smb跳转到重构后的创编流程
export const isSMBRefactorCreationWhite = whiteHelper(whiteValue.refactor_creation_smb);
/** 定时预算白名单 */
export const isScheduledBudgetWhite = whiteHelper(whiteValue.scheduled_budget);

// 默认禁止导入pclite白名单
export const isForbidPcliteRedirect = whiteHelper(whiteValue.s4smb_custom_mode);

export const isTargetingRecommendationWhite = whiteHelper(whiteValue.targeting_recommendation);
export const isTargetingRecommendationNewUIWhite = whiteHelper(whiteValue.targeting_recommendation_newui);

// 是否开启附加创意自定义图片卡白名单
export const isAdditionalImageCardEnable = whiteHelper(whiteValue.additional_customized_image_card);

/** 定向扩量白名单 */
export const isTargetingExpansionWhite = whiteHelper(whiteValue.targeting_expansion);

/** 原生视频推广音乐白名单  */
export const isNativeMusicPromoteWhite = whiteHelper(whiteValue.native_music_promote);
// 游戏礼包码卡片白名单
export const isAdditionalGameGiftCardEnable = whiteHelper(whiteValue.additional_customized_game_gift_card);
// 落地页白名单
export const isAdditionalInstantPageCardEnable = whiteHelper(whiteValue.additional_customized_instant_page);
// RF 落地页白名单，和竞价拆开
export const isAdditionalRfInstantPageEnable = whiteHelper(whiteValue.additional_rf_customized_instant_page);
// 创意是否显示Identity组件
export const isCreativeHasIdentityWhite = () => whiteHelper(whiteValue.account_and_asset_linking)()
  || whiteHelper(whiteValue.new_identity)()
  || whiteHelper(whiteValue.attachement_creative_refact)();

// 创编创意层级重构
export const isNewCreativeStyle = () => whiteHelper(whiteValue.attachement_creative_refact)();


// aco上传素材限制是否解开
export const isAcoUploadUnLockWhite = whiteHelper(whiteValue.aco_max_upload);

// 受众分析升级
export const isUpgradedViewDataWhite = whiteHelper(whiteValue.upgraded_viewdata);

// 定向选项兴趣关键词白名单
export const isInterestKeywordsWhite = whiteHelper(whiteValue.interest_keywords);

// 定向选型行为 hashtag 白名单
export const isHashtagWhite = whiteHelper(whiteValue.hashtag);

/** 创意创建预览使用二维码白名单  */
export const isCreativePreviewWithQrcodeWhite = whiteHelper(whiteValue.creative_preview_with_qrcode);

// 一键申诉白名单
export const isAuditRejectAppealEnable = whiteHelper(whiteValue.audit_reject_appeal);

// 审核雅典娜工单入口白名单
export const isContactServiceWhite = whiteHelper(whiteValue.contact_service);

// ad.site.statistics_i18n 报告接口迁移tt_ads
export const isReportingTTAdsWhite = whiteHelper(whiteValue.reporting_ttads);
// app Profile Instant page 白名单
export const isAppProfileInstantPageEnable = whiteHelper(whiteValue.app_profile_instant_page);

// 商品库资产化白名单
export const isCapitalization = whiteHelper(whiteValue.capitalization);
export const isTransferredCapitalize = () => whiteHelper(whiteValue.need_capitalized)() && isCapitalization();

export const isAutomatedRulesWhite = whiteHelper(whiteValue.automated_rules);

export const isRFEngagementWhite = whiteHelper(whiteValue.rf_engagement);
export const isRFSupportWip = whiteHelper(whiteValue.rf_support_wip);
export const isRFOnlySupportWip = whiteHelper(whiteValue.rf_only_support_wip);

// ACO支持CTA优选白名单
export const isAcoSupportCtaOptimizedWhite = whiteHelper(whiteValue.aco_support_cta_optimized);

// TTBA 原生推视频
export const isTTBAPushNativeVideoAllowed = whiteHelper(whiteValue.ttba_push_native_video);

// 合拍&跟拍 双授权
export const isDoubleAuthorizationWhite = whiteHelper(whiteValue.tiktok_duet_stitch_auth);
export const isRFAppinstall = whiteHelper(whiteValue.rf_appinstall);

// Shop ads
export const isShopWhite = whiteHelper(whiteValue.shop);
export const isShopLiveWhite = whiteHelper(whiteValue.SHOP_LIVE);
export const isVideoShoppingMultiProductsWhite = whiteHelper(whiteValue.video_shopping_multi_products); // video shopping多商品

// searchAds 白名单
export const searchAdsWhite = whiteHelper(whiteValue.search_ads);
export const searchAdsPreviewWhite = whiteHelper(whiteValue.search_ads_preview);

export const tiktokPlayableAdsWhite = whiteHelper(whiteValue.tiktok_playable_ads);
export const isLeadAdsCrmWhite = whiteHelper(whiteValue.lead_ads_crm);

export const isSplitTestSupportIOS14White = whiteHelper(whiteValue.split_test_support_ios_14);

export const isSupportGesture = whiteHelper(whiteValue.rf_gesture);
export const isSupportPaintedEgg = whiteHelper(whiteValue.rf_painted_egg);

export const disclaimerWhite = whiteHelper(whiteValue.disclaimer);
export const rfDisclaimerWhite = whiteHelper(whiteValue.rfDisclaimer);

export const isNewIdentityWhite = whiteHelper(whiteValue.new_identity);

/** [TTP] 白名单 */
export const isHasTTPWhite = whiteHelper(whiteValue.ttp_support);
/** [Clover] 白名单 */
export const isHasCloverWhite = whiteHelper(whiteValue.ads_manager_clover);

// TTP 统计接口白名单
export const isTTPStatisticsApiWhite = whiteHelper(whiteValue.ttp_statistics_api);

// Instant Page - Custom Instant Page/Collection Ads白名单
export const isInstantPageWhite = () => isStoreFrontsPlpWhite() || isBrandAuctionCAWhite() || isAdditionalInstantPageCardEnable();

export const isRFSupportDMP = whiteHelper(whiteValue.rf_dmp);

export const isRFSupportPI = whiteHelper(whiteValue.rf_pi);
export const isContextTarget = whiteHelper(whiteValue.context_target);
export const isPremiumTopic = whiteHelper(whiteValue.context_target_premium);

export const isVideoUploadfrontPrecheckWhite = whiteHelper(whiteValue.videoUploadfrontPrecheck);

export const isMoatWhite = whiteHelper(whiteValue.moat_tagless);
export const isViewIASWhite = whiteHelper(whiteValue.track_view_IAS);
export const isDVWhite = whiteHelper(whiteValue.track_DV);

export const isZefrWhite = whiteHelper(whiteValue.zefrWhite);
export const isBsIasWhite = whiteHelper(whiteValue.bsIasWhite);
export const isBsDvWhite = whiteHelper(whiteValue.bsDvWhite);

// TTP 受众分析业务白名单
export const isTTPStatisticsWhite = whiteHelper(whiteValue.ttp_viewdata_reporting);

// TTP 内部用户 Banner 展示白名单
export const isTTPBannerWhite = whiteHelper(whiteValue.ttp_banner);

// TTP 2fa 白名单
export const isTTP2FAWhite = whiteHelper(whiteValue.ttp_2fa);

// TTP UV Reporting 白名单
export const isTTPUVWhite = whiteHelper(whiteValue.ttp_uv);

export const isBulletboardWhite = whiteHelper(whiteValue.bulletboard);
export const isSupportCreativeMode = whiteHelper(whiteValue.rf_creative_mode);

// CMO 二期 白名单
export const isCMOV2White = whiteHelper(whiteValue.cmo_v2);

export const isDPASupportImage = whiteHelper(whiteValue.dpa_image);

export const isSupportPangleImage = (isDpa = false) => (isDpa ? isDPASupportImage() : isPangleImageWhite());

// CMO 支持 名称排序白名单
export const isCMONameSortWhite = whiteHelper(whiteValue.cmo_name_sort);

// shop live ads优化目标支持product click
export const isLiveSupportProductClick = whiteHelper(whiteValue.shop_live_optimize_goal_product_click);

// shop live ads优化目标支持initate
export const isLiveSupportInitateCheckout = whiteHelper(whiteValue.shop_live_optimize_goal_initate_checkout);

// shop live ads优化目标支持complete payment
export const isLiveSupportCompletePayment = whiteHelper(whiteValue.shop_live_optimize_goal_complete_payment);

// 预定活动开发90天
export const isRf90DaysDelivery = whiteHelper(whiteValue.rf_90_days__delivery);

// 列表页 identity filter 披露白名单
export const isIdentityFilterWhite = () => whiteHelper(whiteValue.new_identity)() || whiteHelper(whiteValue.account_and_asset_linking)();
// 是否支持素材库首页
export const isLibraryDashboardWhite = whiteHelper(whiteValue.library_dashboard);

// 复制rf广告组白名单
export const isRfAdgroupCopy = whiteHelper(whiteValue.rf_adgroup_copy);
// Campaign List 汇总行拆分请求白名单
export const isPerfTotalAsyncWhite = whiteHelper(whiteValue.perf_total_async);

// 医药资质判断
export const isPharmacyQualificationWhite = whiteHelper(whiteValue.pharmacy_qualification);
// 短时切换 Tab 使用缓存
export const isPerfListCacheWhite = whiteHelper(whiteValue.perf_list_cache);
// 表格优化：固定列+虚拟展示
export const isPerfTableOptimizeWhite = whiteHelper(whiteValue.perf_table_optimize);
// 音乐资质简洁流程白名单
export const isMusicSimplifiedAllowed = whiteHelper(whiteValue.music_qualification_simplified_submission);
// URL在Edit场景下是否可编辑
export const isSupportURLEditWhite = whiteHelper(whiteValue.URL_SUPPORT_EDIT);
// Campaign List 按需请求白名单
export const isRequiredCreativeWhite = whiteHelper(whiteValue.required_creative);
// 隐藏优化事件
export const isHideOptimizationEventWhite = whiteHelper(whiteValue.hide_pixel_event);

// 搜索广告明投白名单判断
export const isSearchAdsMtWhite = whiteHelper(whiteValue.search_ads_mt);
// 是否支持 Split Test 投中入口
export const isSplitTestEntryWhite = whiteHelper(whiteValue.split_test_entry);

export const isHtcWhite = whiteHelper(whiteValue.htc);

// Dashboard 接口优化
export const isDashboardApiOptimizeWhite = whiteHelper(whiteValue.dashboard_api_optimize);
// dsa*ca新增白名单
export const isDsaWithCollectionAdWhite = whiteHelper(whiteValue.dsa_with_collection_ad);
// 是否支持shop product anchor投放
export const isShopProductAnchor = whiteHelper(whiteValue.shop_ads_product_anchor);
// dc aeo支持cost cap
export const isAeoDcCostCapWhite = whiteHelper(whiteValue.aeo_dc_cost_cap);
// hhi白名单判断
export const isHhiWhite = whiteHelper(whiteValue.high_household_income);

// dsa * ca迁移白名单
export const isSupportDSAAndCAMigration = whiteHelper(whiteValue.migration_dsa_ca);
export const isSupportDSAAndCANoMigration = whiteHelper(whiteValue.migration_dsa_ca_no_migrate);
export const isSupportMigrationPhaseTwo = whiteHelper(whiteValue.migration_dsa_ca_phase_two);
export const isSupportMigrationPhaseThree = whiteHelper(whiteValue.migration_dsa_ca_phase_three);
export const isSupportMigrationPhaseFour = whiteHelper(whiteValue.migration_dsa_ca_phase_four);

// 在迁移白名单且不在迁移豁免白名单
export const isMigrationDSAAndCAWhite = () => isSupportDSAAndCAMigration() &&
  !isSupportDSAAndCANoMigration();
export const isMigrationPhaseOneWhite = () => isMigrationDSAAndCAWhite() &&
  !isSupportMigrationPhaseTwo();
export const isMigrationPhaseTwoWhite = () => isMigrationDSAAndCAWhite() &&
  isSupportMigrationPhaseTwo();
export const isMigrationPhaseThreeWhite = () => isMigrationDSAAndCAWhite() &&
  isSupportMigrationPhaseThree() &&
  !isSupportMigrationPhaseFour();

export const isMigrationPhaseFourWhite = () => isMigrationDSAAndCAWhite() &&
  isSupportMigrationPhaseFour();

// 禁用 SHOP PURCHASE 的 新增
export const isShopMigration = whiteHelper(whiteValue.migrate_shop_purchase);
// 豁免 SHOP PURCHASE 的 新增
export const isShopNoMigration = whiteHelper(whiteValue.migrate_shop_purchase_exclude);
// 是否禁用 SHOP PURCHASE 的 新增
export const isShopCreateDisabled = () => isShopMigration() && !isShopNoMigration();

// 禁用 SHOP PURCHASE 的 复制、修改
export const isShopMigrationPhase2 = whiteHelper(whiteValue.migrate_shop_purchase_phase2);
// 豁免 SHOP PURCHASE 的 复制、修改
export const isShopNoMigrationPhase2 = whiteHelper(whiteValue.migrate_shop_purchase_edit_copy_exclude);
// 是否禁用 SHOP PURCHASE 的 复制、修改
export const isShopEditCopyDisabled = () => isShopMigrationPhase2() && !isShopNoMigrationPhase2() && isShopCreateDisabled();

// 自动规则相关===
/** @desc 自动规则——是否支持新版本run schedule + run once功能 */
export const isAutomaticRuleRunOnce = whiteHelper(whiteValue.automatic_rule_support_new_schedule);
